<script setup>
import Header from '@crewlixSrc/layout/Header.vue';
</script>

<template>
  <div class="app-root">
    <Header />
    <div class="pt-[50px] min-h-[100vh]">
      <router-view/>
    </div>
  </div>
</template>

